import Image from 'next/image'

const WHY_LIST = [
  {
    icon: './images/payment-ver2/why-1.png',
    title: 'Tránh thất thoát doanh thu',
    description: <span>Không lo khách hàng nhập thiếu số tiền cần thanh toán<br /> Tránh kẻ gian dán đè mã QR, chỉ thông báo khi bạn nhận được tiền thành công</span>,
  }, {
    icon: './images/payment-ver2/why-2.png',
    title: 'Thanh toán nhanh chóng',
    description: <span>Khách hàng không cần nhập số tiền, chỉ cần quét QR bằng ứng dụng ngân hàng là có thể chuyển đúng số tiền cần thanh toán</span>,
  }, {
    icon: './images/payment-ver2/why-3.png',
    title: 'Tăng hiệu suất vận hành',
    description: <span>Thu ngân không cần chụp ảnh màn hình chuyển khoản của khách để đối soát cuối ngày</span>,
  }]
export const Why = () => {
  return (
    <div
      id="loi-ich"
      className="flex flex-col justify-center lg:mt-20 mt-12 lg:mb-8 mb-4 xl:mx-[83px] lg:mx-12 md:ml-8 ml-[18px] lg:gap-12 gap-6 ">
      <div className="mx-auto font-bold md:text-3xl text-2xl leading-9 text-brand-primary-850 text-center md:w-fit w-[297px]">
        Lý do bạn nên sử dụng giải pháp này
      </div>
      <div className="flex md:flex-row flex-col lg:justify-center justify-start gap-6 overflow-auto  no-scrollbar">
        {WHY_LIST.map((why) => (
          <div key={why.title} className="max-lg:mx-auto  flex flex-col justify-between w-[384px] rounded-2xl bg-neutral-25">
            <div className="flex flex-col max-md:justify-center max-md:text-center gap-4 p-6">
              <div className="font-semibold text-[22px] leading-8 text-brand-navy">{why.title}</div>
              <div className="font-normal text-base text-text-strong">{why.description}</div>
            </div>
            <div className="relative h-[280px] w-[384px]">
              <Image src={why.icon} alt={why.title} fill={true} />
            </div>
          </div>
        ))}
      </div>
    </div>)
}